'use strict';

/* eslint-env browser */
module.exports = self;



/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl/js/util/browser/window.js
 ** module id = 18
 ** module chunks = 0
 **/